import React from "react";
import axios from "axios";
import { apiUrl, loginInfo } from "../config";
//import { ToothSample, User,School,initProvince,City, initCity,County, initCounty,Hospital,Grade,Class as Class1 } from "../../../shared/models";
import { message } from "antd";
import { initHospitalLogo } from "../models/HospitalLogo";


export const getAllSamples = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/toothsamples`, {
      headers: {
        suntoken: loginInfo.token,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const getAllCAT = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/cats`, {
      headers: {
        suntoken: loginInfo.token,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const getWorkload = async (
  checkDateBegin:string,
    checkDateEnd:string,
    ageBegin:string,
    ageEnd:string,
    schoolName:string,
    checkName:string,
    cat:number[],
    result:string[]
) => {
  try {
    const { data } = await axios.get(`${apiUrl}/workload`, {
      headers: {
        suntoken: loginInfo.token,
      },
      params: {
        SchoolName: schoolName, 
      BeginDate: checkDateBegin, 
      EndDate: checkDateEnd, 
      BeginAge: ageBegin, 
      EndAge: ageEnd,
      CheckName:checkName,
      Cat:cat,
      Result:result 
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const getCATCount = async (
  checkDateBegin:string,
    checkDateEnd:string,
    ageBegin:string,
    ageEnd:string,
    schoolName:string,
    checkName:string,
    cat:number[],
    result:string[]
) => {
  try {
    const { data } = await axios.get(`${apiUrl}/catcount`, {
      headers: {
        suntoken: loginInfo.token,
      },
      params: {
        SchoolName: schoolName, 
      BeginDate: checkDateBegin, 
      EndDate: checkDateEnd, 
      BeginAge: ageBegin, 
      EndAge: ageEnd,
      CheckName:checkName,
      Cat:cat,
      Result:result 
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const getResultCount = async (
  checkDateBegin:string,
    checkDateEnd:string,
    ageBegin:string,
    ageEnd:string,
    schoolName:string,
    checkName:string,
    cat:number[],
    result:string[]
) => {
  try {
    const { data } = await axios.get(`${apiUrl}/resultcount`, {
      headers: {
        suntoken: loginInfo.token,
      },
      params: {
        SchoolName: schoolName, 
      BeginDate: checkDateBegin, 
      EndDate: checkDateEnd, 
      BeginAge: ageBegin, 
      EndAge: ageEnd,
      CheckName:checkName,
      Cat:cat,
      Result:result 
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const download = async () => {
  try {
    const { data } = await axios.get(`${apiUrl}/download`, {
      headers: {
        suntoken: loginInfo.token,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const isSchoolCodeExist = async (
  hospitalId: number,
  schoolCode: string
) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "exist",
        type: "school",
        Id: hospitalId,
        code: schoolCode,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const isSchoolCodeChangeExist = async (
  hospitalId: number,
  schoolId: number,
  schoolCode: string
) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "changeExist",
        type: "school",
        upId: hospitalId,
        Id: schoolId,
        code: schoolCode,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const newSchoolCode = async (hospitalId: number) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "new",
        type: "school",
        upId: hospitalId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const isGradeCodeExist = async (schoolId: number, code: string) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "exist",
        type: "grade",
        upId: schoolId,
        code: code,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const isGradeCodeChangeExist = async (
  schoolId: number,
  gradeId: number,
  code: string
) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "changeExist",
        type: "grade",
        upId: schoolId,
        Id: gradeId,
        code: code,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const newGradeCode = async (schoolId: number) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "new",
        type: "grade",
        UpId: schoolId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const isClassCodeExist = async (gradeId: number, code: string) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "exist",
        type: "class",
        code: code,
        upId: gradeId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const isClassCodeChangeExist = async (
  gradeId: number,
  classId: number,
  code: string
) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "changeExist",
        type: "class",
        code: code,
        upId: gradeId,
        Id: classId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const newClassCode = async (gradeId: number) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "new",
        type: "class",
        upId: gradeId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const isStudentCodeExist = async (classId: number, code: string) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "exist",
        type: "student",
        code: code,
        upId: classId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const isStudentCodeChangeExist = async (
  classId: number,
  studentId: number,
  code: string
) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "changeExist",
        type: "student",
        code: code,
        Id: studentId,
        upId: classId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    if (data === "true") {
      return true;
    } else {
      return false;
    }
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};
export const newStudentCode = async (classId: number) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/code`,
      {
        Op: "new",
        type: "student",
        upId: classId,
      },
      {
        headers: {
          suntoken: loginInfo.token,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const getTableAll = async (table: string) => {
  try {
    const { data } = await axios.get(`${apiUrl}/table`, {
      headers: {
        suntoken: loginInfo.token,
        suntable: table,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const getTable = async (table: string, id: number) => {
  try {
    const { data } = await axios.get(`${apiUrl}/table/${id}`, {
      headers: {
        suntoken: loginInfo.token,
        suntable: table,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const createTable = async (table: string, obj: Object) => {
  try {
    const { data } = await axios.post(
      `${apiUrl}/table`,
      {
        ...obj,
      },
      {
        headers: {
          suntoken: loginInfo.token,
          suntable: table,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const updateTable = async (table: string, obj: Object) => {
  try {
    let id: number = obj["id"];
    const { data } = await axios.put(
      `${apiUrl}/table/${id}`,
      {
        ...obj,
        Id: id,
      },
      {
        headers: {
          suntoken: loginInfo.token,
          suntable: table,
        },
      }
    );
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const deleteTable = async (table: string, id: number) => {
  try {
    await axios.delete(`${apiUrl}/table/${id}`, {
      headers: {
        suntoken: loginInfo.token,
        suntable: table,
      },
    });
    return { id: id };
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const doLogin = async (userCode: string, userPwd: string,type:string) => {
  const { data } = await axios.post(
    `${apiUrl}/login`,
    {
      UserCode: userCode,
      UserPwd: userPwd,
    },
    {
      headers: {
        suntoken: loginInfo.token,
        logintype:type,
      },
    }
  );
  return data;
};

export const buildReport = async (ids: string) => {
  try {
    const { data } = await axios.get(`${apiUrl}/report/1`, {
      headers: {
        suntoken: loginInfo.token,
        sunreportids:ids,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return undefined;
  }
};

export const getLogoByHospital = async (id: number) => {
  try {
    const { data } = await axios.get(`${apiUrl}/hospitallogo/${id}`, {
      headers: {
        suntoken: loginInfo.token,
      },
    });
    return data;
  } catch (err: any) {
    if (err.response.status === 401) {
      message.warning("用户登录时间过长，请重新登录!");
    }
    return initHospitalLogo;
  }
};